import { Datagrid, AutocompleteInput, List, TextField, Edit, Filter, TextInput, DateField, DateInput, DeleteWithConfirmButton } from "ra-ui-materialui";
import { useState, useEffect } from "react";
import {
    useRedirect
} from "react-admin";
import { PostBulkActionButtonsPermision } from "./utils";
import { useEditContext } from "ra-core";
import { getScaleStatus } from "../services/master-tables.service";
import { validateCustomDate } from "./utils";
import ScaleForm from "../components/Scale/ScaleForm";
import moment from "moment";
import { saveAs } from "file-saver";


const XLSX = require("xlsx");


export const ScaleList = props => {

    const customExporter = async (data, fetchRelatedRecords, dataProvider) => {
        const pageSize = 1000;
        let currentPage = 2;
        let allData = [...data];
        let hasMoreData = true;
        const filter = props?.clientId ? { clientId: props.clientId } : {};

        if (data.length === pageSize) {
            try {
                while (hasMoreData) {
                    const { data: pageData } = await dataProvider.getList('scales', {
                        filter,
                        pagination: { page: currentPage, perPage: pageSize },
                        sort: { field: 'id', order: 'DESC' },
                    });

                    allData = [...allData, ...pageData];
                    hasMoreData = pageData.length === pageSize;
                    currentPage += 1;
                }
            } catch (error) {
                console.error('Error durante la exportación de escalas con paginación:', error);
            }
        }

        exportScales(allData);
    };

    const exportScales = scales => {
        const scaleList = scales.map(scale => ({
            'Id': scale?.id,
            'Escala': scale?.scaleName,
            'Estado de la Escala': scale?.scaleStatusName,
            'Fecha de creación': scale?.createdDate ? moment(scale.createdDate).format('DD-MM-YYYY') : '',
            'Usuario': scale?.clientName,
            'Profesional': scale?.professionalName,
            'Área': scale?.areaName,
            'Contrato': scale?.contractName,
            'Puntuación': scale?.totalScore,
        }));

        const worksheet = XLSX.utils.json_to_sheet(scaleList);
        worksheet["!cols"] = [
            { wch: 10 },
            { wch: 35 },
            { wch: 24 },
            { wch: 20 },
            { wch: 35 },
            { wch: 35 },
            { wch: 30 },
            { wch: 30 },
            { wch: 15 },
        ];
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Escalas');
        const xlsxBlob = XLSX.write(workbook, {
            bookType: 'xlsx',
            type: 'array',
        });

        saveAs(new Blob([xlsxBlob], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        }), 'escalas.xlsx');
    };

    return (
        <List title={props?.hideTitle ? <span /> : <span>Gestión de Escalas</span>} bulkActionButtons={props?.permissions?.scales?.delete ? <PostBulkActionButtonsPermision perm="scales.delete" /> : false} exporter={customExporter} sort={{ field: 'Id', order: 'DESC' }} filters={<ScaleFilter />} filterDefaultValues={{ clientId: props?.clientId }} {...props}>
            <Datagrid rowClick="edit" isRowSelectable={record => props?.permissions?.scales?.delete}>
                <TextField label="Id" source="id" />
                <TextField label="Escala" source="scaleName" />
                <TextField label="Estado de la Escala" source="scaleStatusName" />
                <DateField label="Fecha de creación" source="createdDate" />                
                <TextField label="Usuario" source="clientName" />
                <TextField label="Profesional" source="professionalName" />
                <TextField label="Área" source="areaName" />
                <TextField label="Contrato" source="contractName" />
                <TextField label="Puntuación" source="totalScore" />
                {
                    props?.permissions?.scales?.delete ?
                        <DeleteWithConfirmButton
                            label="Eliminar"
                            confirmTitle="Eliminar escala"
                            confirmContent="¿Seguro que quiere eliminar esta escala?"
                            mutationMode="pessimistic"
                        />
                        : null
                }
            </Datagrid>
        </List>
    );
}


const ScaleEditContent = () => {
    const { record } = useEditContext(); // Eliminamos basePath si no se usa
    const redirect = useRedirect();
    
    if (!record) return null;

    return (
        <ScaleForm
            isNew={false}
            data={record}
            isDisabled={record?.scaleStatusName !== "En curso"}
            onCancel={() => {
                if (record?.clientId) {
                    redirect(`/users/${record.clientId}/6`);
                } else {
                    redirect('/scales');
                }
            }}
        />
    );
};

export const ScaleEdit = (props) => {

    return (
        <Edit title={<ScaleTitle />} mutationMode="pessimistic" {...props} transform={transformScaleEdit}>
            <ScaleEditContent />
        </Edit>
    );
};

const ScaleTitle = ({ record }) => {
    if (!record) return <span />;
    // Los registros de escala tienen clientName/scaleName, no 'name'
    const title = record.scaleName
        ? `Escala: ${record.scaleName} · ${record.clientName || ''}`.trim()
        : (record.clientName ? `Cliente: ${record.clientName}` : '');
    return <span>{title}</span>;
};


const ScaleFilter = (props) => {

    const [scaleStatus, setScaleStatus] = useState();

     useEffect(() => {
             getScaleStatus().then(
                 res => {
                     setScaleStatus(res?.elements);
                 }
             )
         }, []);
         
    return (
        <Filter {...props}>
            <TextInput label="Id" source="id" />
            <TextInput label="Escala" source="scaleName" alwaysOn />
            <TextInput label="Usuario" source="clientName" alwaysOn />
            <TextInput label="Contrato" source="contractName" alwaysOn />
            <TextInput label="Area" source="areaName" alwaysOn />
            
            {
                scaleStatus ?
                    <AutocompleteInput
                        label="Estado"
                        source="scaleStatusId"
                        choices={scaleStatus}
                        optionText="value"
                        optionValue="id"
                        options={{ InputProps: { autoComplete: 'off' } }}
                        resettable={true}
                    />
                    : null
            }
            <TextInput label="Nombre de Profesional" source="professionalName"  />
            <DateInput label="Fecha de Creación" source="createdDate" validate={[validateCustomDate('Error de Formato')]} />

        </Filter>
    );
}


const transformScaleEdit = (data) => {
    //const createTime = data.createTime ? moment(data.createTime).format('yyyy-MM-DDTHH:mm:ss') : null;
    return {
        ...data
    }
}
